export default __webpack_public_path__ + "static/reporter-star-5476a23f1e45eb8d7ba6be12db79fdab.png";